<script setup>
import {onMounted, ref, computed} from 'vue';
import store from "@/store";
import router from "@/router";
const props = defineProps({

  modelValue: {},
  arrivingToday: {type: Boolean, default: true },
  monthAhead: {type: Boolean, default: false },
})

const hoverColor = computed(() => {

  if(props.arrivingToday) return '#545454';
  if(props.monthAhead) return '#b0bcea';

  return '#f3d0d0'
})

const textColor = computed(() => {

  if(props.arrivingToday) return 'var(--grid-cell-date-due-today)';
  if(props.monthAhead) return '#524185';

  return '#b01510'
})

const modeIcon = (mode) => {

  switch (mode) {

    case('courier'):
      return 'fa-regular fa-truck-fast'
      break;

    case('air'):
      return 'fa-regular fa-plane cmp-selectable-date-list_mode-air'
      break;

    case('rail'):
      return 'fa-regular fa-train cmp-selectable-date-list_mode-rail'
      break;

    case('sea'):
      return 'fa-regular fa-ship cmp-selectable-date-list_mode-sea'
      break;

    case('road'):
      return 'fa-regular fa-truck'
      break;
  }

}

function viewSelectedShipment(item) {

  store.state.hideLoadingSpinner = false;

  try {

    router.push({ name: 'viewshipment', params: { owner: store.state.owner, mode: item.mode, id: item.id }})

  } catch (error) {

    store.state.hideLoadingSpinner = true;
  }

}


</script>

<template>
  <div class="cmp-selectable-date-list">
    <div class="cmp-selectable-date-list_headers" :class="{'cmp-selectable-date-list_grid-arriving-today' :
          props.arrivingToday, 'cmp-selectable-date-list_grid-late' : !props.arrivingToday}">
      <div>Customer Ref</div>
      <div>Job No.</div>
      <div>Mode</div>
      <div>Type</div>
      <div v-if="!props.arrivingToday">Est. Date</div>
    </div>
    <div class="cmp-selectable-date-list_list-container">
      <div v-for="item in modelValue" class="cmp-selectable-date-list_item-container" @click="viewSelectedShipment(item)">
          <div :class="{'cmp-selectable-date-list_grid-arriving-today' :
           props.arrivingToday, 'cmp-selectable-date-list_grid-late' : !props.arrivingToday}">
            <div :title="item.customerRef">{{item.customerRef}}</div>
            <div :title="item.jobNumber">{{item.jobNumber}}</div>
            <div :title="item.mode"><i :class="modeIcon(item.mode)" class="cmp-selectable-date-list_mode-icon"></i></div>
            <div>{{item.jobType}}
              <i v-if="props.arrivingToday"
                 class="fa-regular fa-arrow-up-right-from-square cmp-selectable-date-list_link-icon" style="font-size: 13px">
              </i>
            </div>
            <div v-if="!props.arrivingToday">{{item.date}}
              <i class="fa-regular fa-arrow-up-right-from-square cmp-selectable-date-list_link-icon" style="font-size: 13px;">
              </i>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>

.cmp-selectable-date-list {

  font-size: 13px;

  &_grid-arriving-today {
    display: grid;
    grid-template-columns: 180px 100px 50px 60px;
    gap: 10px;
  }

  &_grid-late {
    display: grid;
    grid-template-columns: 110px 60px 50px 40px 80px;
    gap: 20px;
  }

  &_headers {
    margin-top: 10px;
    align-items: center;
    padding: 0 0 4px 10px;
    font-weight: bold;
    font-size: 12px;
  }

  &_list-container {
    overflow-y: auto;
    overflow-x: hidden;
    height: 190px;
    margin: 8px 6px 0 6px;
    min-width: 440px;
  }

  &_item-container {
    display: flex;
    border-bottom: 1px solid #eaeaea;
    height: 20px;
    align-items: center;
    color: v-bind(textColor);
    padding-left: 4px;
    font-size: 11px;
  }

  &_item-container:nth-child(even) {
    background-color: #f8f8f8;
  }

  &_item-container div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &_item-container:hover &_link-icon {
    visibility: visible;
    color: #ffffff;
    margin-left: 10px;
  }

  &_item-container:hover &_mode-icon {
    color: #ffffff;
    opacity: 1;
  }

  &_item-container:hover {
    //background-color: #545454;
    background-color: v-bind(hoverColor)
  }

  &_link-icon {
    visibility: hidden;
  }

  &_mode-icon {
    margin-left: 8px;
    font-size: 12px;
    color: var(--aqua-blue-definition);
    opacity: 0.5;
  }

  &_mode-air {
    font-size: 13px;
  }

  &_mode-rail {
    font-size: 13px;
    margin-left: 9px;
  }

  &_mode-sea {
    font-size: 13px;
    margin-left: 7px;
  }
}
</style>
